import classNames from 'classnames';
import React, { FC } from 'react';
import { Icon } from '../Icon';
import styles from './LangSwitcher.module.scss';

type LangSwitcherProps = {
	variant?: 'button';
};

export const LangSwitcherLabel: FC<LangSwitcherProps> = ({ variant, children }) => {
	return (
		<div
			className={classNames(styles.langSwitcherLabel, 'langSwitcherLabel', {
				[styles[`langSwitcherLabel--${variant}`]]: variant,
				'btn btn-outline-dark': variant === 'button',
			})}
		>
			<span className={styles.langSwitcherIcon}>
				<Icon.Globe />
			</span>
			{children}
		</div>
	);
};
